import { todayPlusFormatted } from "helpers/date";
import useExternalApiService from "helpers/ExternalApiService";
import { store } from 'stores/Store';
import { useState } from "react";

export interface LatestPractitionersUpdated {
  practitioners: any[] | null,
  fetchPractitioners: () => void;
}

const API_URL = process.env.REACT_APP_EAI_URL

export const useLatestPractitionersUpdated = (): LatestPractitionersUpdated => {
  const [practitioners, setPractitioners] = useState<any[] | null>(null);
  const { postData } = useExternalApiService(API_URL);

  const fetchPractitioners = () => {
    const cutoffDate = todayPlusFormatted(-30);
    const params = new URLSearchParams({
      cutoff_date: cutoffDate,
    });

    postData(`/api/practitioners/latest?${params.toString()}`, {
      fmc_email: store.impersonatedUser,
    })
      .then((response) => {
        if (response) {
          setPractitioners(response.practitioners);
        }
      });
  };

  return {
    practitioners,
    fetchPractitioners,
  };
};